import React, { Component } from 'react';
import { toast } from 'react-toastify';
import _ from 'lodash'
import { Button, Checkbox } from 'carbon-components-react';
import { StepCard } from '../../index';
import { getDmService } from '../../../services/Api';

class KitProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advanced: false,
      disabledAdvance: false,
      listSizePredefined: []
    };
  }

  componentWillReceiveProps = async (newProps) => {
    const { dataProduct } = newProps;
    const grupos = await getDmService('/ProdutoCategoria');
    if (dataProduct.hasOwnProperty('productSave')) {
      let list = [];
      const filterGroup = grupos.filter(x => x.nome === dataProduct.productSave.label);
      const filterProducts = await getDmService(`/ProdutoDescricao/GetByGrupo/?grupo=${filterGroup[0].id}`);

      filterProducts.forEach(async (item) => {
        const produto = await getDmService(`/ProdutoAgencia/GetByProduto/?produtoId=${item.id}`);
        list.push({ checked: false, amountSize: 0, value: item, produto: produto });
        this.setState({
          listSizePredefined: list
        });
      })
    }
  };

  renderDescription = () => {
    return (
      <p className="description">
        Tamanho do produto, sendo um tamanho padrão ou um campo variável que
        deverá ser combinado com a coluna de medida do campo variável.
      </p>
    )
  };

  checkedSizes = (val, idx, isFirstLoad) => {
    const { listSizePredefined } = this.state;
    const copyList = _.clone(listSizePredefined, true);

    if (copyList && (copyList.length - 1) >= idx) {
      listSizePredefined[idx].checked = val;
      listSizePredefined[idx].indice = idx;

      if (listSizePredefined[idx].value.isLarguraVariavel) {
        listSizePredefined[idx].showWidthVariable = val
      }
      if (listSizePredefined[idx].value.isAlturaVariavel) {
        listSizePredefined[idx].showHeigthVariable = val
      }
      if (typeof isFirstLoad === 'undefined') {
        copyList.forEach((item, index) => {
          if (item.checked === false) {
            listSizePredefined[index].amountSize = 0
            listSizePredefined[index].heightSize = 0
            listSizePredefined[index].widthSize = 0
          }
        })
      }

      this.setState({
        listSizePredefined: copyList
      });
    }
  };

  advance = async () => {
    const { saveStep } = this.props;
    // const { variableSave, dataFilters } = dataProduct;
    // const labelVariable = variableSave && variableSave.value ? variableSave.value : variableSave.label ? variableSave.label : "";

    const {
      listSizePredefined
    } = this.state;

    const checkedsPredefineds = await listSizePredefined.filter(item => (item.checked === true));

    if (checkedsPredefineds.length > 0) {
      await saveStep({
        listSizes: checkedsPredefineds
      });
    } else {
      toast.warn("Você precisa selecionar uma das opções do kit para avançar.");
    }

    await this.stepCardRef.toggleContent();
  }

  cancel = () => {
    this.stepCardRef.toggleContent();
  }

  render() {
    const {
      advanced,
      disabledAdvance,
      listSizePredefined,
    } = this.state;

    const { disabledCard, isFinished } = this.props;

    return (
      <StepCard
        onRef={ref => {
          this.stepCardRef = ref;
        }
        }
        title="Produto e Quantidade"
        description={this.renderDescription()}
        isFinished={isFinished}
        onToogle={advanced}
        disabled={disabledCard}
      >
        <div>
          <div className="bx--row ">
            <div className="bx--col-xs-6 bx--col-md-3 v-md-margin">
              <p className="legend-size-qtde-agency">
                Produto
              </p>
            </div>
          </div>
          {listSizePredefined.length && (
            listSizePredefined.map((item, index) => (
              <div key={index}>
                <div className="bx--row ">
                  <div className="bx--col-xs-6 bx--col-md-3 v-md-margin">
                    <Checkbox
                      id={`itemCheck${index}`}
                      className="check-sizes-requests"
                      labelText={item.value.nome}
                      checked={item.checked}
                      onChange={e => this.checkedSizes(e, index)}
                    />
                  </div>
                  <div className="bx--col-xs-6 bx--col-md-2 v-md-margin">
                    <input
                      className="bx--text-input bx--text__input"
                      type="text"
                      min={item.produto.quantidadeMinima}
                      id="amountSize"
                      value={item.produto.quantidadeMinima}
                      disabled
                    />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
        <div className="bx--row">
          <div className="bx--col-xs-12 bx--col-md-12 v-md-margin">
            <Button
              onClick={this.advance}
              className="bx--btn btn-secondary-color"
              disabled={disabledAdvance}
            >
              Avançar
            </Button>
            <Button
              kind="ghost"
              className="bx--btn btn-secondary-outlined h-sm-margin"
              onClick={this.cancel}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </StepCard>
    )
  }

}

export default KitProducts;



// WEBPACK FOOTER //
// ./src/components/agency/requests/KitProducts.js